import { render, staticRenderFns } from "./telephoneDoctor.vue?vue&type=template&id=e6b694d0&scoped=true"
import script from "./telephoneDoctor.vue?vue&type=script&lang=js"
export * from "./telephoneDoctor.vue?vue&type=script&lang=js"
import style0 from "./telephoneDoctor.vue?vue&type=style&index=0&id=e6b694d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b694d0",
  null
  
)

export default component.exports